import { Music, CheckCircle2 } from "lucide-react";
import { formatTime12h } from "../../lib/schedule";
import { getStudentTypeStyle } from "../../lib/studentTypes";

export function StudentProfileCard({ student, progress }) {
    const initials = student.name
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join("");

    const typeStyle = getStudentTypeStyle(student.type);
    const TypeIcon = typeStyle.icon;

    return (
        <section className="lg:col-span-1 bg-white rounded-3xl border border-mist card-soft p-6 sm:p-8">
            <div className="w-20 h-20 rounded-3xl bg-action-soft text-[#3D6385] font-display font-bold text-3xl flex items-center justify-center mb-5">
                {initials}
            </div>
            <h1 className="font-display font-bold text-3xl uppercase tracking-tight text-slate-900 leading-tight">
                {student.name}
            </h1>
            <div className="mt-2 flex items-center gap-2 text-slate-500">
                <Music size={14} strokeWidth={2.5} />
                <span className="font-bold">{student.instrument}</span>
            </div>

            <div className="mt-5 flex items-center gap-2">
                <span
                    className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${typeStyle.chip}`}
                >
                    <TypeIcon size={12} strokeWidth={3} />
                    {student.type}
                </span>
            </div>

            <div className="mt-7">
                <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 mb-3">
                    Weekly Schedule
                </div>
                {!student.days || student.days.length === 0 ? (
                    <div className="text-sm text-slate-500">No schedule.</div>
                ) : (
                    <ul className="space-y-2">
                        {student.days.map((d) => (
                            <li
                                key={d}
                                className="flex items-center justify-between p-3 rounded-xl bg-mist/50 border border-mist"
                            >
                                <span className="font-bold text-sm text-slate-700">{d}</span>
                                <span className="font-display font-bold text-slate-900">
                                    {formatTime12h(student.schedule?.[d]) || "—"}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <div className="mt-7 p-5 rounded-2xl bg-gradient-to-br from-action-soft to-brand-soft border border-mist">
                <div className="flex items-baseline justify-between mb-1">
                    <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-600">
                        Monthly Progress
                    </div>
                    <div className="font-display font-bold text-2xl text-slate-900">
                        {progress.units}
                        <span className="text-slate-400"> / {progress.target}</span>
                    </div>
                </div>
                {progress.target > 0 && (
                    <div className="text-[11px] font-medium text-slate-500 mb-2">
                        Month {progress.cycle} · {progress.target} sessions per month
                    </div>
                )}
                <div className="h-3 rounded-full bg-white overflow-hidden">
                    <div
                        className={`h-full rounded-full transition-all ${
                            progress.complete ? "bg-success" : "bg-[#3D6385]"
                        }`}
                        style={{ width: `${progress.pct}%` }}
                    />
                </div>
                {progress.complete && (
                    <div className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-success uppercase tracking-wider">
                        <CheckCircle2 size={14} strokeWidth={2.8} />
                        Month {progress.cycle} complete
                    </div>
                )}
            </div>
        </section>
    );
}
